import {appendUrlParam, device, fetchDataByAjax, getPageUrlParams, md5, parseUrl, watchdog} from '../../common/util'
import {generateMofV3RequestUrl} from '../../common/tool'
import {reportNonBizData} from '../../common/m_common/mNonBizReport'
import {reportUrlList} from '../../common/m_common/mBizReport'
import {reportPV} from "../../common/report";
import MoreOffer from '../component/visible/MoreOffer'
import BannerMoreOffer from '../component/visible/BannerMoreOffer'

export default class BannerMoreOfferManager {
    constructor(opts = {}) {
        // App 实例
        this.App = opts.APP || {}
        // 标识当前 more offer 是否 ready，可以随时展示了
        this.uiLoadSuccess = false
        // 主 offer initData
        this.initData = this.App && this.App.initData;
        // 主 offer
        this.campaign = opts.campaign || (this.initData && this.initData.campaignList[0])
        // 主 offer unit id，android banner unit_id 位置为 unitSetting.unitId
        this.mainAdUnitId = this.initData && this.initData.unit_id || this.initData.unitSetting.unitId || '';
        // more offer unit id（动态下发）
        this.mof_uid = getPageUrlParams('mof_uid')
        // more offer 测试 unit id（动态下发）
        this.mof_testuid = getPageUrlParams('mof_testuid')
        // 主 offer only_impression_url
        this.objOnlyImpUrl = parseUrl(this.campaign && this.campaign.only_impression_url)
        //  only_impression_url
        this.objOnlyImp = parseUrl(this.initData && this.initData.only_impression_url)
        // 主 offer onlyImp 维度的 request id
        this.mainOfferRid = this.objOnlyImp && this.objOnlyImp.params && this.objOnlyImp.params.k
        // 主 offer 的 offer_id
        this.offer_id && this.campaign.id
        // 传入的 options
        this.options = opts
        // more offer 批量上报 - 批量上报开关 ,banner 写死支持批量上报，不支持参数下发
        // this.nImpEnabled = getPageUrlParams('n_imp') === '1'
        this.nImpEnabled = true
        // more offer 批量上报 - 要上报的域名和接口
        this.batchImpInterface = `https://tknet.rayjump.com/batchimp?`
        // more offer 批量上报 - 上次 scroll 的位置
        this.lastPosition = 0
        // more offer 批量上报 - 单个 offer 宽
        this.widthPerOffer = 24
        // more offer 批量上报 - 已经批量上报过的部分
        this.nImpReportHistory = []
        // 已上报的 offer 数量(从左往右)
        this.batchImpReportedNumber = 0
        // 用来标识当前是否正在进行批量上报, 确保同时只有一次批量上报请求
        this.isBatchImpReporting = false
        // 标识当前 more offer 是否 ready，可以随时展示了
        if (typeof opts.loadTimeout === 'number') {
            this.loadTimeout = opts.loadTimeout
        } else {
            this.loadTimeout = 10
        }
        //  banner 主 unit_id 对应的 more offer unit_id
        this.unitIdMap = {
            android: {
                323996: 470118,
                438413: 470120,
                491496: 470122,
                478451: 470124,
                1538179: 470126,
                146879: 470118, // demo uint_id
            },
            ios: {
                386743: 470108,
                504540: 470110,
                449112: 470112,
                340438: 470114,
                425506: 470116,
                146898: 470108,// demo uint_id
            }
        }
        // 系统
        this.platform = device().isAndroid ? "android" : "ios";
        // 当前banner more offer 的 unit_id
        this.unit_id = this.unitIdMap[this.platform][this.mainAdUnitId]
        // 固定兜底的 app_id
        this.app_id = this.platform == "android" ? 142256 : 142257
        // 固定兜底的 sign
        this.sign = this.platform == "android" ? '23eaaa07fbfd2b1d733de180d704f749' : '07364c3048880833c510944586bd6217'
        // 请求 more offer 广告接口的路径
        this.mofReqPath = 'openapi/ad/v3'
        // 初始化 MoreOffer 基础组件，绑定 "click、scroll、onError" 等事件
        this.init()
    }

    init() {
        const mofOpts = Object.assign(this.options, {
            onLoadSuccess: this.options.onLoadSuccess || [],
            onLoadFailed: this.options.onLoadFailed || [() => {
                console.log('Load failed!')
                this.reportMofTracking({reportType: 'mtg_mof_loadFailed'})
            }],
            title: this.options.title,
        })
        this.options.onLoadSuccess.push((e) => {
            this.render()
        })
        // 绑定滚动时批量上报事件
        if (this.nImpEnabled) {
            this.options.onScroll.push(() => {
                this.batchImpReport()
            })
        }
        if (this.options.offerData) {
            // mofOpts.offerData = this.options.offerData
            console.log('more offer mode: offerData mode')
        } else {
            if (this.options.moftype === "1") {
                mofOpts.url = this.generateRequestUrl({
                    ad_num: 10,
                    tnum: 10,
                    unit_id: this.unit_id,
                    app_id: this.app_id,
                    sign: this.sign,
                    h5_type: 4
                })
            } else {
                mofOpts.url = this.generateRequestUrl({
                    ad_num: 1,
                    tnum: 1,
                    unit_id: this.unit_id,
                    app_id: this.app_id,
                    sign: this.sign,
                    h5_type: 4
                })
            }
            console.log('more offer mode: ajax url mode')
        }
        if (this.options.moftype == "1") {
            this.moreOfferInstance = new MoreOffer(mofOpts)
        } else if (this.options.moftype == "2") {
            this.moreOfferInstance = new BannerMoreOffer(mofOpts)
        }
        this.bindEvent()
    }

    render() {
        // 尝试渲染“参你喜欢”
        this.moreOfferInstance.render()
        watchdog({
            condition: () => {
                return this.moreOfferInstance.checkIconStatus(0, this.options.readyLength)
            },
            callback: () => {
                console.log('Mof ready!')
                this.uiLoadSuccess = true
                this.reportMofTracking({reportType: 'mtg_mof_ready'})
                this.options.onReady.forEach((func) => {
                    func()
                })
            },
            timeoutCallback: () => {
                // init 阶段等待渲染超时
                this.reportMofTracking({reportType: 'mtg_mof_notReady'})
            },
            maxDuration: this.loadTimeout * 1000,
            interval: 1000,
        })
        if (this.options.moftype == "1") {
            let eleFirstOfferItem = this.moreOfferInstance.element.querySelector('.mtg-recommend-item');
            if (eleFirstOfferItem instanceof Element) {
                let computedStyle = window.getComputedStyle(eleFirstOfferItem, null);
                this.widthPerOffer = computedStyle && computedStyle.width
            } else {
                console.error('MOF UI [first Offer Item] undefined')
            }
        }
    }

    appendTo(target = document.body) {
        // 挂载并显示 more offer
        this.moreOfferInstance.appendTo(target)
        // onlyImp 上报
        reportPV([this.getOnlyImpression()])
        // 批量上报
        this.nImpEnabled && this.batchImpReport()
        // show 埋点上报
        this.reportMofTracking({reportType: 'mtg_mof_show'})
    }

    show(startTime) {
        // 用最长 5 秒的时间等待猜你喜欢资源加载完毕, 并在 ready 时动画展示猜你喜欢区域
        // 如果约定时限内资源没有加载完毕, 则不再尝试展示猜你喜欢, 并上报超时埋点
        watchdog({
            condition: () => {
                return this.uiLoadSuccess
            },
            callback: () => {
                // 如果满足条件可以展示时, 距离 webviewshow 已经过去了 1 秒以上, 就直接动画展示, 不再等待
                if (Date.now() - startTime > 1000) {
                    this.appendTo(document.getElementsByClassName("swiper2")[0])
                } else {
                    // 否则就延迟 1 秒再展示
                    setTimeout(() => {
                        this.appendTo(document.getElementsByClassName("swiper2")[0])
                    }, 1000)
                }
            },
            timeoutCallback: () => {
                // show 阶段等待超时
                // 上报超时埋点
                console.warn('show more offer 等待 10s 超时')
                this.reportMofTracking({reportType: 'mtg_mof_loadTimeout'})
            },
            maxDuration: this.loadTimeout * 1000,
            interval: 100,
        })
    }

    bindEvent() {
        this.moreOfferInstance.onError((e) => {
            console.log('Resource load error!')
            this.reportMofTracking({reportType: 'mtg_mof_error'})
            this.options.onError.forEach((func) => {
                func(e)
            })
        })

        this.moreOfferInstance.onOfferClick(({event, campaign}) => {
            console.log('more offer clicked!')
            this.reportMofTracking({reportType: 'mtg_mof_click'})
            this.options.onOfferClick.forEach((func) => {
                func({event, campaign})
            })
            event.stopPropagation()
        })
        // 为scroll事件加入节流机制
        this.moreOfferInstance.onScroll((scrollX) => {
            this.createThrottle((scrollX) => {
                console.log('createThrottle: invoked.')
                this.options.onScroll.forEach((func) => {
                    console.log('this.options.onScroll.forEach fired.')
                    func(scrollX)
                })
            }, 300)(scrollX)
        })
    }

    setCampaign(newCamp) {
        this.campaign = newCamp
    }

    generateRequestUrl(params) {
        const paramList = generateMofV3RequestUrl(this.initData, this.campaign, params,"banner")
        // let retUrl = `https://net.rayjump.com/${this.mofReqPath}`;
        let retUrl = `http://rgx-pre.rayjump.com/${this.mofReqPath}`;
        console.error('注意：当前请求的为测试环境 more offer 接口，rgx-pre.rayjump.com');
        retUrl = this.replaceDomainForEG(retUrl)
        retUrl = this.replaceAdPathForCROS(retUrl)
        for (const property in paramList) {
            retUrl = appendUrlParam(retUrl, property, paramList[property])
        }
        console.log('generateRequestUrl: ', retUrl)
        return retUrl
    }

    createThrottle(func, wait) {
        let throttle = (function () {
            let timeout,
                context,
                args,
                startTime = Date.parse(new Date())
            return function () {
                let curTime = Date.parse(new Date())
                let remaining = wait - (curTime - startTime)
                context = this
                args = arguments
                clearTimeout(timeout)
                if (remaining <= 0) {
                    func.apply(context, args)
                    startTime = Date.parse(new Date())
                } else {
                    timeout = setTimeout(() => {
                        func.apply(context, args)
                    }, remaining)
                }
            }
        })()
        return throttle
    }

    /**
     * more offer: 将用户浏览过的 campaign 信息发送给批量上报接口, 每个 campaign 只会上报一次, 重复浏览不上报
     * @returns {boolean} 如果为重复浏览或者上报信息为空, 则调用此方法时会中止上报, 并返回 false
     */
    batchImpReport() {
        // 如果当前有正在上报中的请求, 则拒绝接受新的上报请求
        if (this.isBatchImpReporting) {
            console.log('当前有正在上报中的请求, 拒绝接受新的上报请求')
            return false
        }

        /**
         * 根据滚动距离获取当前需要上报的 offer 数
         */
            // 初始化 "offer 列表" 和 "单个 offer", 通过计算来获取已展示过的 offer 数量
        let intBatchImpShowedNumber = 1;
        if (this.options.moftype === "1") {
            let offerScroller = document.querySelector(`.mtg-recommend-list-box`)
            let offerItem = document.querySelector(`.mtg-recommend-item`)
            // 用来存储屏幕上已经展示过的 offer 数量
            intBatchImpShowedNumber = Math.round((offerScroller.scrollLeft + offerScroller.offsetWidth) / offerItem.offsetWidth)
        }
        if (intBatchImpShowedNumber <= this.batchImpReportedNumber) {
            console.log('当前展示都已上报过了, 暂时不需要上报')
            return false
        }


        /**
         * 初始化批量 imp 上报所需的 "campaign id 列表" 和对应的 "imp url 列表"
         */
            // 初始化当前 offer res data
        let mofRes = this.moreOfferInstance.getMofRes();

        // 获取当前 offer 列表
        let mofOfferList = mofRes && mofRes.data && JSON.parse(JSON.stringify(mofRes.data.ads))

        // 获取当前 request id
        let mofOnlyImp = parseUrl(mofRes && mofRes.data && mofRes.data.only_impression_url)
        let mofRequestId = mofOnlyImp && mofOnlyImp.params && mofOnlyImp.params.k

        // 用来存储上报的 "campaign id 列表" 和对应的 "imp url 列表"
        let arrTempCids = []
        let arrTempImps = []
        if (this.options.moftype === "1") {
            mofOfferList = mofOfferList.splice(0, 10)
        } else if (this.options.moftype === "2") {
            mofOfferList = mofOfferList.splice(0, 1)
        }
        // process
        mofOfferList.forEach((item, index) => {
            if (index > this.batchImpReportedNumber - 1
                && index <= intBatchImpShowedNumber - 1) {
                arrTempCids.push(item.id)
                arrTempImps.push(item.impression_url)
            }
        })
        // 如果获取不到 request id, 或者要上报的 "campaign id 列表" 或 "imp url 列表" 为空, 则中止上报
        if (!mofRequestId || arrTempCids.length === 0 || arrTempImps.length === 0) {
            console.warn('requestId 或 上报内容长度为空, 中止上报 => ', mofRequestId, arrTempCids, arrTempImps)
            return false
        }

        // 拼接要上报的 url 地址和 data
        this.batchImpInterface = this.replaceDomainForEG(this.batchImpInterface)
        let batchImpUrl = `${this.batchImpInterface}k=${mofRequestId}&cids=${arrTempCids.join('.')}`
        let batchImpData = JSON.stringify({"imps": arrTempImps})

        /**
         * 开始批量 imp 上报
         */
        // 当前即将开启新的上报请求, 标记 "批量 imp" 的当前状态为: 上报中
        this.isBatchImpReporting = true
        fetchDataByAjax('POSTJSON', batchImpUrl, batchImpData, (res) => {
            res = JSON.parse(res)

            // 上报成功
            if (Number(res.status) === 1) {
                // 更新已上报的数量
                this.batchImpReportedNumber = intBatchImpShowedNumber
            } else {
                // 上报失败
                console.warn('EC_MOF: batch impression failed: ', res)
            }
            // 重置批量上报状态标识
            this.isBatchImpReporting = false
        }, (err) => {
            // 上报出现错误
            console.warn('EC_MOF: batch impression error: ', err)
            // 重置批量上报状态标识
            this.isBatchImpReporting = false
        })
    }

    getOnlyImpression() {
        return this.moreOfferInstance.onlyImpression
    }

    setBackgroundColor(color = 'white') {
        this.moreOfferInstance.setBG(color)
    }

    // more offer 埋点上报
    reportMofTracking({reportType, reportApiClass = 'BannerJSPlugin', dataCustomized = {}}) {
        let nonBizData = {
            reportType,
            reportApiClass,
            dataCustomized,
        }
        nonBizData.dataCustomized.ad_r_id = this.mainOfferRid

        // mof_uid 开启时, 埋点上报会尽量和 v3 请求保持一致，带上真实 unit_id app_id sign 等
        if (this.mof_testuid || this.mof_uid) {
            console.log('mof_uid or mof_testuid enabled')
            // more offer unit id（服务端下发）
            nonBizData.dataCustomized.appwall_unit = this.mof_testuid || this.mof_uid
            // SDK 真实的 app_id
            nonBizData.dataCustomized.app_id = this.initData && this.initData.device && this.initData.device.appId
            // SDK 真实的 sign
            nonBizData.dataCustomized.sign = this.initData && this.initData.device && md5(nonBizData.dataCustomized.app_id + this.initData.device.appkey || '')
            // SDK 真实的主 offer unit id（未兜底时使用的字段名为 parent_unit）
            nonBizData.dataCustomized.parent_unit = this.mainAdUnitId
        } else {
            // 如果当前既没有 mof_uid，也没有 mof_testuid，则埋点上报时使用固定值兜底（区分 iOS Android）
            console.log('mof_uid or mof_testuid disabled')
            // 固定兜底的 more offer unit id
            nonBizData.dataCustomized.appwall_unit = this.unit_id
            // 固定兜底的 app_id
            nonBizData.dataCustomized.app_id = this.app_id;
            // 固定兜底的 sign
            nonBizData.dataCustomized.sign = this.sign;
            // 真实的主 offer unit id（兜底时使用的字段名为 uc_parent_unit）
            nonBizData.dataCustomized.uc_parent_unit = this.mainAdUnitId;
        }

        // 如果开启了批量上报, 则需要额外增加以下参数
        if (this.nImpEnabled) {
            // 固定值 - 用来标识该请求为一次 H5 的 more offer 请求: 0 和不传表示普通的appwall请求, 1 表示more offer请求
            nonBizData.dataCustomized.mof = 1
            // 固定值 - 用来标识当前 more offer 的版本号, 每次版本更新+1, 当前版本为 2
            nonBizData.dataCustomized.mof_ver = 4
        }

        // 【hybrid: EC_MOF.js: reportRecommendAnalytics()】
        // 【老的 EC_MOF 埋点上报，调用通用埋点上报之后补充的定制逻辑】
        // more offer 埋点定制逻辑
        // 主 offer 的 unit id
        nonBizData.dataCustomized.unit_id = this.mainAdUnitId
        // 主 offer 的 offer id
        nonBizData.dataCustomized.offer_id = this.offer_id

        // 固定值 - 用来区分 endcard、playable、播放模板，
        // 1 表示endcard；
        // 2 表示playable；
        // 3 表示新架构下的播放模板, 如（v11 始终固定为 3）
        // 4 表示 banner
        nonBizData.dataCustomized.h5_type = 4

        reportNonBizData(nonBizData)
    }
    replaceDomainForEG(url) {
        let ct = ''
        try {
            ct = this.initData.appSetting.country_code;
        }catch(err) {}
        if (ct === 'EG') {
            url = url && url.replace(/rayjump\.com/, 'mintegral.net')
        }
        console.log('当前ct===>', ct)
        console.log('rayjump当前替换后域名url===>', url)
        return url;
    }

    /**
     * 背景：开发者集成的 safesdk 在 App 层面拦截修改了 openapi/ad/v3 接口的响应头，
     * 导致 more offer 请求广告时因为浏览器跨域限制，脚本报错，无法显示 more offer 广告。
     * 排查后发现规律：请求广告接口时如果路径中包含 /openapi/ad，more offer 就会出现问题，
     * 可能是被 applovin 的 safesdk 针对了，但也不排除和具体开发者集成的 safesdk 版本，以及集成方式有关系。
     *
     * 所以这里要针对有问题的场景更换 more offer 请求路径，规避此问题：
     * https://confluence.mobvista.com/pages/viewpage.action?pageId=58844055
     */
    replaceAdPathForCROS (url) {
        let customMofReqPath = getPageUrlParams('mof_req_path')
        if (url && customMofReqPath) {
            url = url.replace(this.mofReqPath, decodeURIComponent(customMofReqPath))
            this.reportMofTracking({reportType: 'mtg_mof_path_replaced'})
        } else {
            this.reportMofTracking({reportType: 'mtg_mof_path_not_replaced'})
        }
        return url
    }
}